import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretRightDouble32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCaretRightDouble32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.707 6.793a1 1 0 1 0-1.414 1.414L23.086 16l-7.793 7.793a1 1 0 0 0 1.414 1.414l8.5-8.5.707-.707-.707-.707zm-8.5 0a1 1 0 0 0-1.414 1.414L14.586 16l-7.793 7.793a1 1 0 1 0 1.414 1.415l8.5-8.5.707-.708-.707-.707z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretRightDouble32);
